import { objectSpread2 as _objectSpread2, defineProperty as _defineProperty, toConsumableArray as _toConsumableArray } from '../_virtual/_rollupPluginBabelHelpers.js';
import fastMemoize from 'fast-memoize';

var FontScales = /*#__PURE__*/function (FontScales) {
  FontScales[FontScales["none"] = 0] = "none";
  FontScales[FontScales["lp1-16"] = 1] = "lp1-16";
  FontScales[FontScales["lp2-8"] = 2] = "lp2-8";
  FontScales[FontScales["lp8-2"] = 3] = "lp8-2";
  FontScales[FontScales["mn3-6"] = 4] = "mn3-6";
  FontScales[FontScales["mj2-9"] = 5] = "mj2-9";
  FontScales[FontScales["a4-3"] = 6] = "a4-3";
  FontScales[FontScales["mn2-16"] = 7] = "mn2-16";
  FontScales[FontScales["lp1-15"] = 8] = "lp1-15";
  FontScales[FontScales["mn2-15"] = 9] = "mn2-15";
  FontScales[FontScales["gr-2"] = 10] = "gr-2";
  FontScales[FontScales["mj2-8"] = 11] = "mj2-8";
  FontScales[FontScales["mn3-5"] = 12] = "mn3-5";
  FontScales[FontScales["mn2-14"] = 13] = "mn2-14";
  FontScales[FontScales["mj3-4"] = 14] = "mj3-4";
  FontScales[FontScales["lp1-14"] = 15] = "lp1-14";
  FontScales[FontScales["lp2-7"] = 16] = "lp2-7";
  FontScales[FontScales["p4-3"] = 17] = "p4-3";
  FontScales[FontScales["mn2-13"] = 18] = "mn2-13";
  FontScales[FontScales["mj2-7"] = 19] = "mj2-7";
  FontScales[FontScales["p5-2"] = 20] = "p5-2";
  FontScales[FontScales["lp1-13"] = 21] = "lp1-13";
  FontScales[FontScales["mn2-12"] = 22] = "mn2-12";
  FontScales[FontScales["mn3-4"] = 23] = "mn3-4";
  FontScales[FontScales["mn2-11"] = 24] = "mn2-11";
  FontScales[FontScales["mj2-6"] = 25] = "mj2-6";
  FontScales[FontScales["lp1-12"] = 26] = "lp1-12";
  FontScales[FontScales["lp2-6"] = 27] = "lp2-6";
  FontScales[FontScales["a4-2"] = 28] = "a4-2";
  FontScales[FontScales["mj3-3"] = 29] = "mj3-3";
  FontScales[FontScales["mn2-10"] = 30] = "mn2-10";
  FontScales[FontScales["lp1-11"] = 31] = "lp1-11";
  FontScales[FontScales["mj2-5"] = 32] = "mj2-5";
  FontScales[FontScales["mn2-9"] = 33] = "mn2-9";
  FontScales[FontScales["p4-2"] = 34] = "p4-2";
  FontScales[FontScales["mn3-3"] = 35] = "mn3-3";
  FontScales[FontScales["lp1-10"] = 36] = "lp1-10";
  FontScales[FontScales["lp2-5"] = 37] = "lp2-5";
  FontScales[FontScales["mn2-8"] = 38] = "mn2-8";
  FontScales[FontScales["gr-1"] = 39] = "gr-1";
  FontScales[FontScales["mj2-4"] = 40] = "mj2-4";
  FontScales[FontScales["lp1-9"] = 41] = "lp1-9";
  FontScales[FontScales["mn2-7"] = 42] = "mn2-7";
  FontScales[FontScales["mj3-2"] = 43] = "mj3-2";
  FontScales[FontScales["lp1-8"] = 44] = "lp1-8";
  FontScales[FontScales["lp2-4"] = 45] = "lp2-4";
  FontScales[FontScales["lp8-1"] = 46] = "lp8-1";
  FontScales[FontScales["p5-1"] = 47] = "p5-1";
  FontScales[FontScales["mn2-6"] = 48] = "mn2-6";
  FontScales[FontScales["mn3-2"] = 49] = "mn3-2";
  FontScales[FontScales["mj2-3"] = 50] = "mj2-3";
  FontScales[FontScales["a4-1"] = 51] = "a4-1";
  FontScales[FontScales["lp1-7"] = 52] = "lp1-7";
  FontScales[FontScales["mn2-5"] = 53] = "mn2-5";
  FontScales[FontScales["lp1-6"] = 54] = "lp1-6";
  FontScales[FontScales["lp2-3"] = 55] = "lp2-3";
  FontScales[FontScales["p4-1"] = 56] = "p4-1";
  FontScales[FontScales["mn2-4"] = 57] = "mn2-4";
  FontScales[FontScales["mj2-2"] = 58] = "mj2-2";
  FontScales[FontScales["lp1-5"] = 59] = "lp1-5";
  FontScales[FontScales["mj3-1"] = 60] = "mj3-1";
  FontScales[FontScales["mn2-3"] = 61] = "mn2-3";
  FontScales[FontScales["lp1-4"] = 62] = "lp1-4";
  FontScales[FontScales["lp2-2"] = 63] = "lp2-2";
  FontScales[FontScales["mn3-1"] = 64] = "mn3-1";
  FontScales[FontScales["lp1-3"] = 65] = "lp1-3";
  FontScales[FontScales["mn2-2"] = 66] = "mn2-2";
  FontScales[FontScales["mj2-1"] = 67] = "mj2-1";
  FontScales[FontScales["lp1-2"] = 68] = "lp1-2";
  FontScales[FontScales["lp2-1"] = 69] = "lp2-1";
  FontScales[FontScales["mn2-1"] = 70] = "mn2-1";
  FontScales[FontScales["lp1-1"] = 71] = "lp1-1";
  FontScales[FontScales["base"] = 72] = "base";
  FontScales[FontScales["lp1+1"] = 73] = "lp1+1";
  FontScales[FontScales["mn2+1"] = 74] = "mn2+1";
  FontScales[FontScales["lp1+2"] = 75] = "lp1+2";
  FontScales[FontScales["lp2+1"] = 76] = "lp2+1";
  FontScales[FontScales["lp1+3"] = 77] = "lp1+3";
  FontScales[FontScales["mj2+1"] = 78] = "mj2+1";
  FontScales[FontScales["mn2+2"] = 79] = "mn2+2";
  FontScales[FontScales["lp1+4"] = 80] = "lp1+4";
  FontScales[FontScales["lp2+2"] = 81] = "lp2+2";
  FontScales[FontScales["mn3+1"] = 82] = "mn3+1";
  FontScales[FontScales["lp1+5"] = 83] = "lp1+5";
  FontScales[FontScales["mn2+3"] = 84] = "mn2+3";
  FontScales[FontScales["lp1+6"] = 85] = "lp1+6";
  FontScales[FontScales["lp2+3"] = 86] = "lp2+3";
  FontScales[FontScales["mj3+1"] = 87] = "mj3+1";
  FontScales[FontScales["mj2+2"] = 88] = "mj2+2";
  FontScales[FontScales["lp1+7"] = 89] = "lp1+7";
  FontScales[FontScales["mn2+4"] = 90] = "mn2+4";
  FontScales[FontScales["p4+1"] = 91] = "p4+1";
  FontScales[FontScales["lp1+8"] = 92] = "lp1+8";
  FontScales[FontScales["lp2+4"] = 93] = "lp2+4";
  FontScales[FontScales["lp8+1"] = 94] = "lp8+1";
  FontScales[FontScales["lp1+9"] = 95] = "lp1+9";
  FontScales[FontScales["mn2+5"] = 96] = "mn2+5";
  FontScales[FontScales["a4+1"] = 97] = "a4+1";
  FontScales[FontScales["lp1+10"] = 98] = "lp1+10";
  FontScales[FontScales["lp2+5"] = 99] = "lp2+5";
  FontScales[FontScales["mj2+3"] = 100] = "mj2+3";
  FontScales[FontScales["mn3+2"] = 101] = "mn3+2";
  FontScales[FontScales["lp1+11"] = 102] = "lp1+11";
  FontScales[FontScales["mn2+6"] = 103] = "mn2+6";
  FontScales[FontScales["lp1+12"] = 104] = "lp1+12";
  FontScales[FontScales["lp2+6"] = 105] = "lp2+6";
  FontScales[FontScales["p5+1"] = 106] = "p5+1";
  FontScales[FontScales["lp1+13"] = 107] = "lp1+13";
  FontScales[FontScales["mj3+2"] = 108] = "mj3+2";
  FontScales[FontScales["mn2+7"] = 109] = "mn2+7";
  FontScales[FontScales["lp1+14"] = 110] = "lp1+14";
  FontScales[FontScales["lp2+7"] = 111] = "lp2+7";
  FontScales[FontScales["mj2+4"] = 112] = "mj2+4";
  FontScales[FontScales["gr+1"] = 113] = "gr+1";
  FontScales[FontScales["lp1+15"] = 114] = "lp1+15";
  FontScales[FontScales["lp1+16"] = 115] = "lp1+16";
  FontScales[FontScales["lp2+8"] = 116] = "lp2+8";
  FontScales[FontScales["lp8+2"] = 117] = "lp8+2";
  FontScales[FontScales["mn2+8"] = 118] = "mn2+8";
  FontScales[FontScales["lp1+17"] = 119] = "lp1+17";
  FontScales[FontScales["mn3+3"] = 120] = "mn3+3";
  FontScales[FontScales["lp1+18"] = 121] = "lp1+18";
  FontScales[FontScales["lp2+9"] = 122] = "lp2+9";
  FontScales[FontScales["p4+2"] = 123] = "p4+2";
  FontScales[FontScales["lp1+19"] = 124] = "lp1+19";
  FontScales[FontScales["mn2+9"] = 125] = "mn2+9";
  FontScales[FontScales["mj2+5"] = 126] = "mj2+5";
  FontScales[FontScales["lp1+20"] = 127] = "lp1+20";
  FontScales[FontScales["lp2+10"] = 128] = "lp2+10";
  FontScales[FontScales["mn2+10"] = 129] = "mn2+10";
  FontScales[FontScales["lp2+11"] = 130] = "lp2+11";
  FontScales[FontScales["mj3+3"] = 131] = "mj3+3";
  FontScales[FontScales["a4+2"] = 132] = "a4+2";
  FontScales[FontScales["lp2+12"] = 133] = "lp2+12";
  FontScales[FontScales["lp8+3"] = 134] = "lp8+3";
  FontScales[FontScales["mj2+6"] = 135] = "mj2+6";
  FontScales[FontScales["mn2+11"] = 136] = "mn2+11";
  FontScales[FontScales["mn3+4"] = 137] = "mn3+4";
  FontScales[FontScales["lp2+13"] = 138] = "lp2+13";
  FontScales[FontScales["lp2+14"] = 139] = "lp2+14";
  FontScales[FontScales["mn2+12"] = 140] = "mn2+12";
  FontScales[FontScales["lp2+15"] = 141] = "lp2+15";
  FontScales[FontScales["p5+2"] = 142] = "p5+2";
  FontScales[FontScales["mj2+7"] = 143] = "mj2+7";
  FontScales[FontScales["mn2+13"] = 144] = "mn2+13";
  FontScales[FontScales["lp2+16"] = 145] = "lp2+16";
  FontScales[FontScales["lp8+4"] = 146] = "lp8+4";
  FontScales[FontScales["p4+3"] = 147] = "p4+3";
  FontScales[FontScales["lp2+17"] = 148] = "lp2+17";
  FontScales[FontScales["mj3+4"] = 149] = "mj3+4";
  FontScales[FontScales["mn2+14"] = 150] = "mn2+14";
  FontScales[FontScales["mn3+5"] = 151] = "mn3+5";
  FontScales[FontScales["lp2+18"] = 152] = "lp2+18";
  return FontScales;
}({});
var SpaceScales = /*#__PURE__*/function (SpaceScales) {
  SpaceScales[SpaceScales["none"] = 0] = "none";
  SpaceScales[SpaceScales["lp1-14"] = 1] = "lp1-14";
  SpaceScales[SpaceScales["lp2-7"] = 2] = "lp2-7";
  SpaceScales[SpaceScales["a4-6"] = 3] = "a4-6";
  SpaceScales[SpaceScales["p5-5"] = 4] = "p5-5";
  SpaceScales[SpaceScales["mj3-9"] = 5] = "mj3-9";
  SpaceScales[SpaceScales["p4-7"] = 6] = "p4-7";
  SpaceScales[SpaceScales["mj2-17"] = 7] = "mj2-17";
  SpaceScales[SpaceScales["mn3-11"] = 8] = "mn3-11";
  SpaceScales[SpaceScales["gr-4"] = 9] = "gr-4";
  SpaceScales[SpaceScales["mj2-16"] = 10] = "mj2-16";
  SpaceScales[SpaceScales["mn3-10"] = 11] = "mn3-10";
  SpaceScales[SpaceScales["mj3-8"] = 12] = "mj3-8";
  SpaceScales[SpaceScales["mj2-15"] = 13] = "mj2-15";
  SpaceScales[SpaceScales["a4-5"] = 14] = "a4-5";
  SpaceScales[SpaceScales["p4-6"] = 15] = "p4-6";
  SpaceScales[SpaceScales["lp1-13"] = 16] = "lp1-13";
  SpaceScales[SpaceScales["mj2-14"] = 17] = "mj2-14";
  SpaceScales[SpaceScales["mn3-9"] = 18] = "mn3-9";
  SpaceScales[SpaceScales["p5-4"] = 19] = "p5-4";
  SpaceScales[SpaceScales["mj3-7"] = 20] = "mj3-7";
  SpaceScales[SpaceScales["mj2-13"] = 21] = "mj2-13";
  SpaceScales[SpaceScales["mn3-8"] = 22] = "mn3-8";
  SpaceScales[SpaceScales["gr-3"] = 23] = "gr-3";
  SpaceScales[SpaceScales["p4-5"] = 24] = "p4-5";
  SpaceScales[SpaceScales["mj2-12"] = 25] = "mj2-12";
  SpaceScales[SpaceScales["lp1-12"] = 26] = "lp1-12";
  SpaceScales[SpaceScales["lp2-6"] = 27] = "lp2-6";
  SpaceScales[SpaceScales["a4-4"] = 28] = "a4-4";
  SpaceScales[SpaceScales["mj3-6"] = 29] = "mj3-6";
  SpaceScales[SpaceScales["mn2-20"] = 30] = "mn2-20";
  SpaceScales[SpaceScales["mj2-11"] = 31] = "mj2-11";
  SpaceScales[SpaceScales["mn3-7"] = 32] = "mn3-7";
  SpaceScales[SpaceScales["mn2-19"] = 33] = "mn2-19";
  SpaceScales[SpaceScales["p5-3"] = 34] = "p5-3";
  SpaceScales[SpaceScales["mj2-10"] = 35] = "mj2-10";
  SpaceScales[SpaceScales["mn2-18"] = 36] = "mn2-18";
  SpaceScales[SpaceScales["lp1-11"] = 37] = "lp1-11";
  SpaceScales[SpaceScales["p4-4"] = 38] = "p4-4";
  SpaceScales[SpaceScales["mj3-5"] = 39] = "mj3-5";
  SpaceScales[SpaceScales["mn2-17"] = 40] = "mn2-17";
  SpaceScales[SpaceScales["mn3-6"] = 41] = "mn3-6";
  SpaceScales[SpaceScales["mj2-9"] = 42] = "mj2-9";
  SpaceScales[SpaceScales["mn2-16"] = 43] = "mn2-16";
  SpaceScales[SpaceScales["a4-3"] = 44] = "a4-3";
  SpaceScales[SpaceScales["lp1-10"] = 45] = "lp1-10";
  SpaceScales[SpaceScales["lp2-5"] = 46] = "lp2-5";
  SpaceScales[SpaceScales["mn2-15"] = 47] = "mn2-15";
  SpaceScales[SpaceScales["gr-2"] = 48] = "gr-2";
  SpaceScales[SpaceScales["mj2-8"] = 49] = "mj2-8";
  SpaceScales[SpaceScales["mn3-5"] = 50] = "mn3-5";
  SpaceScales[SpaceScales["mn2-14"] = 51] = "mn2-14";
  SpaceScales[SpaceScales["mj3-4"] = 52] = "mj3-4";
  SpaceScales[SpaceScales["p4-3"] = 53] = "p4-3";
  SpaceScales[SpaceScales["mn2-13"] = 54] = "mn2-13";
  SpaceScales[SpaceScales["lp1-9"] = 55] = "lp1-9";
  SpaceScales[SpaceScales["mj2-7"] = 56] = "mj2-7";
  SpaceScales[SpaceScales["p5-2"] = 57] = "p5-2";
  SpaceScales[SpaceScales["mn2-12"] = 58] = "mn2-12";
  SpaceScales[SpaceScales["mn3-4"] = 59] = "mn3-4";
  SpaceScales[SpaceScales["mn2-11"] = 60] = "mn2-11";
  SpaceScales[SpaceScales["mj2-6"] = 61] = "mj2-6";
  SpaceScales[SpaceScales["lp1-8"] = 62] = "lp1-8";
  SpaceScales[SpaceScales["lp2-4"] = 63] = "lp2-4";
  SpaceScales[SpaceScales["lp8-1"] = 64] = "lp8-1";
  SpaceScales[SpaceScales["a4-2"] = 65] = "a4-2";
  SpaceScales[SpaceScales["mj3-3"] = 66] = "mj3-3";
  SpaceScales[SpaceScales["mn2-10"] = 67] = "mn2-10";
  SpaceScales[SpaceScales["mj2-5"] = 68] = "mj2-5";
  SpaceScales[SpaceScales["mn2-9"] = 69] = "mn2-9";
  SpaceScales[SpaceScales["lp1-7"] = 70] = "lp1-7";
  SpaceScales[SpaceScales["p4-2"] = 71] = "p4-2";
  SpaceScales[SpaceScales["mn3-3"] = 72] = "mn3-3";
  SpaceScales[SpaceScales["mn2-8"] = 73] = "mn2-8";
  SpaceScales[SpaceScales["gr-1"] = 74] = "gr-1";
  SpaceScales[SpaceScales["mj2-4"] = 75] = "mj2-4";
  SpaceScales[SpaceScales["lp1-6"] = 76] = "lp1-6";
  SpaceScales[SpaceScales["lp2-3"] = 77] = "lp2-3";
  SpaceScales[SpaceScales["mn2-7"] = 78] = "mn2-7";
  SpaceScales[SpaceScales["mj3-2"] = 79] = "mj3-2";
  SpaceScales[SpaceScales["p5-1"] = 80] = "p5-1";
  SpaceScales[SpaceScales["mn2-6"] = 81] = "mn2-6";
  SpaceScales[SpaceScales["lp1-5"] = 82] = "lp1-5";
  SpaceScales[SpaceScales["mn3-2"] = 83] = "mn3-2";
  SpaceScales[SpaceScales["mj2-3"] = 84] = "mj2-3";
  SpaceScales[SpaceScales["a4-1"] = 85] = "a4-1";
  SpaceScales[SpaceScales["mn2-5"] = 86] = "mn2-5";
  SpaceScales[SpaceScales["lp1-4"] = 87] = "lp1-4";
  SpaceScales[SpaceScales["lp2-2"] = 88] = "lp2-2";
  SpaceScales[SpaceScales["p4-1"] = 89] = "p4-1";
  SpaceScales[SpaceScales["mn2-4"] = 90] = "mn2-4";
  SpaceScales[SpaceScales["mj2-2"] = 91] = "mj2-2";
  SpaceScales[SpaceScales["mj3-1"] = 92] = "mj3-1";
  SpaceScales[SpaceScales["lp1-3"] = 93] = "lp1-3";
  SpaceScales[SpaceScales["mn2-3"] = 94] = "mn2-3";
  SpaceScales[SpaceScales["mn3-1"] = 95] = "mn3-1";
  SpaceScales[SpaceScales["lp1-2"] = 96] = "lp1-2";
  SpaceScales[SpaceScales["lp2-1"] = 97] = "lp2-1";
  SpaceScales[SpaceScales["mn2-2"] = 98] = "mn2-2";
  SpaceScales[SpaceScales["mj2-1"] = 99] = "mj2-1";
  SpaceScales[SpaceScales["mn2-1"] = 100] = "mn2-1";
  SpaceScales[SpaceScales["lp1-1"] = 101] = "lp1-1";
  SpaceScales[SpaceScales["base"] = 102] = "base";
  SpaceScales[SpaceScales["lp1+1"] = 103] = "lp1+1";
  SpaceScales[SpaceScales["mn2+1"] = 104] = "mn2+1";
  SpaceScales[SpaceScales["lp1+2"] = 105] = "lp1+2";
  SpaceScales[SpaceScales["lp2+1"] = 106] = "lp2+1";
  SpaceScales[SpaceScales["mj2+1"] = 107] = "mj2+1";
  SpaceScales[SpaceScales["mn2+2"] = 108] = "mn2+2";
  SpaceScales[SpaceScales["lp1+3"] = 109] = "lp1+3";
  SpaceScales[SpaceScales["mn3+1"] = 110] = "mn3+1";
  SpaceScales[SpaceScales["mn2+3"] = 111] = "mn2+3";
  SpaceScales[SpaceScales["lp1+4"] = 112] = "lp1+4";
  SpaceScales[SpaceScales["lp2+2"] = 113] = "lp2+2";
  SpaceScales[SpaceScales["mj3+1"] = 114] = "mj3+1";
  SpaceScales[SpaceScales["mj2+2"] = 115] = "mj2+2";
  SpaceScales[SpaceScales["mn2+4"] = 116] = "mn2+4";
  SpaceScales[SpaceScales["lp1+5"] = 117] = "lp1+5";
  SpaceScales[SpaceScales["p4+1"] = 118] = "p4+1";
  SpaceScales[SpaceScales["lp1+6"] = 119] = "lp1+6";
  SpaceScales[SpaceScales["lp2+3"] = 120] = "lp2+3";
  SpaceScales[SpaceScales["mn2+5"] = 121] = "mn2+5";
  SpaceScales[SpaceScales["a4+1"] = 122] = "a4+1";
  SpaceScales[SpaceScales["mj2+3"] = 123] = "mj2+3";
  SpaceScales[SpaceScales["lp1+7"] = 124] = "lp1+7";
  SpaceScales[SpaceScales["mn3+2"] = 125] = "mn3+2";
  SpaceScales[SpaceScales["mn2+6"] = 126] = "mn2+6";
  SpaceScales[SpaceScales["lp1+8"] = 127] = "lp1+8";
  SpaceScales[SpaceScales["lp2+4"] = 128] = "lp2+4";
  SpaceScales[SpaceScales["lp8+1"] = 129] = "lp8+1";
  SpaceScales[SpaceScales["p5+1"] = 130] = "p5+1";
  SpaceScales[SpaceScales["lp1+9"] = 131] = "lp1+9";
  SpaceScales[SpaceScales["mj3+2"] = 132] = "mj3+2";
  SpaceScales[SpaceScales["mn2+7"] = 133] = "mn2+7";
  SpaceScales[SpaceScales["mj2+4"] = 134] = "mj2+4";
  SpaceScales[SpaceScales["gr+1"] = 135] = "gr+1";
  SpaceScales[SpaceScales["lp1+10"] = 136] = "lp1+10";
  SpaceScales[SpaceScales["lp2+5"] = 137] = "lp2+5";
  SpaceScales[SpaceScales["mn2+8"] = 138] = "mn2+8";
  SpaceScales[SpaceScales["lp1+11"] = 139] = "lp1+11";
  SpaceScales[SpaceScales["mn3+3"] = 140] = "mn3+3";
  SpaceScales[SpaceScales["lp1+12"] = 141] = "lp1+12";
  SpaceScales[SpaceScales["lp2+6"] = 142] = "lp2+6";
  SpaceScales[SpaceScales["p4+2"] = 143] = "p4+2";
  SpaceScales[SpaceScales["mn2+9"] = 144] = "mn2+9";
  SpaceScales[SpaceScales["mj2+5"] = 145] = "mj2+5";
  SpaceScales[SpaceScales["lp1+13"] = 146] = "lp1+13";
  SpaceScales[SpaceScales["lp1+14"] = 147] = "lp1+14";
  SpaceScales[SpaceScales["lp2+7"] = 148] = "lp2+7";
  SpaceScales[SpaceScales["mn2+10"] = 149] = "mn2+10";
  SpaceScales[SpaceScales["lp1+15"] = 150] = "lp1+15";
  SpaceScales[SpaceScales["mj3+3"] = 151] = "mj3+3";
  SpaceScales[SpaceScales["a4+2"] = 152] = "a4+2";
  SpaceScales[SpaceScales["lp1+16"] = 153] = "lp1+16";
  SpaceScales[SpaceScales["lp2+8"] = 154] = "lp2+8";
  SpaceScales[SpaceScales["lp8+2"] = 155] = "lp8+2";
  SpaceScales[SpaceScales["mj2+6"] = 156] = "mj2+6";
  SpaceScales[SpaceScales["mn2+11"] = 157] = "mn2+11";
  SpaceScales[SpaceScales["lp1+17"] = 158] = "lp1+17";
  SpaceScales[SpaceScales["mn3+4"] = 159] = "mn3+4";
  SpaceScales[SpaceScales["lp1+18"] = 160] = "lp1+18";
  SpaceScales[SpaceScales["lp2+9"] = 161] = "lp2+9";
  SpaceScales[SpaceScales["mn2+12"] = 162] = "mn2+12";
  SpaceScales[SpaceScales["lp1+19"] = 163] = "lp1+19";
  SpaceScales[SpaceScales["lp1+20"] = 164] = "lp1+20";
  SpaceScales[SpaceScales["lp2+10"] = 165] = "lp2+10";
  SpaceScales[SpaceScales["p5+2"] = 166] = "p5+2";
  SpaceScales[SpaceScales["mj2+7"] = 167] = "mj2+7";
  SpaceScales[SpaceScales["mn2+13"] = 168] = "mn2+13";
  SpaceScales[SpaceScales["p4+3"] = 169] = "p4+3";
  SpaceScales[SpaceScales["lp2+11"] = 170] = "lp2+11";
  SpaceScales[SpaceScales["mj3+4"] = 171] = "mj3+4";
  SpaceScales[SpaceScales["mn2+14"] = 172] = "mn2+14";
  SpaceScales[SpaceScales["mn3+5"] = 173] = "mn3+5";
  SpaceScales[SpaceScales["lp2+12"] = 174] = "lp2+12";
  SpaceScales[SpaceScales["lp8+3"] = 175] = "lp8+3";
  SpaceScales[SpaceScales["mj2+8"] = 176] = "mj2+8";
  SpaceScales[SpaceScales["gr+2"] = 177] = "gr+2";
  SpaceScales[SpaceScales["lp2+13"] = 178] = "lp2+13";
  SpaceScales[SpaceScales["mn2+15"] = 179] = "mn2+15";
  SpaceScales[SpaceScales["lp2+14"] = 180] = "lp2+14";
  SpaceScales[SpaceScales["mn2+16"] = 181] = "mn2+16";
  SpaceScales[SpaceScales["a4+3"] = 182] = "a4+3";
  SpaceScales[SpaceScales["lp2+15"] = 183] = "lp2+15";
  SpaceScales[SpaceScales["mj2+9"] = 184] = "mj2+9";
  SpaceScales[SpaceScales["mn3+6"] = 185] = "mn3+6";
  SpaceScales[SpaceScales["lp2+16"] = 186] = "lp2+16";
  SpaceScales[SpaceScales["lp8+4"] = 187] = "lp8+4";
  SpaceScales[SpaceScales["mn2+17"] = 188] = "mn2+17";
  SpaceScales[SpaceScales["mj3+5"] = 189] = "mj3+5";
  SpaceScales[SpaceScales["lp2+17"] = 190] = "lp2+17";
  SpaceScales[SpaceScales["p4+4"] = 191] = "p4+4";
  SpaceScales[SpaceScales["mn2+18"] = 192] = "mn2+18";
  SpaceScales[SpaceScales["mj2+10"] = 193] = "mj2+10";
  SpaceScales[SpaceScales["lp2+18"] = 194] = "lp2+18";
  SpaceScales[SpaceScales["lp2+19"] = 195] = "lp2+19";
  SpaceScales[SpaceScales["p5+3"] = 196] = "p5+3";
  SpaceScales[SpaceScales["mn2+19"] = 197] = "mn2+19";
  SpaceScales[SpaceScales["lp2+20"] = 198] = "lp2+20";
  SpaceScales[SpaceScales["lp8+5"] = 199] = "lp8+5";
  SpaceScales[SpaceScales["mn3+7"] = 200] = "mn3+7";
  SpaceScales[SpaceScales["mj2+11"] = 201] = "mj2+11";
  SpaceScales[SpaceScales["mn2+20"] = 202] = "mn2+20";
  SpaceScales[SpaceScales["mj3+6"] = 203] = "mj3+6";
  SpaceScales[SpaceScales["a4+4"] = 204] = "a4+4";
  SpaceScales[SpaceScales["lp8+6"] = 205] = "lp8+6";
  return SpaceScales;
}({});
function generateIntegersArray(l) {
  return Array.from({
    length: l
  }, function (v, k) {
    return k + 1;
  });
}
var ScalesStepsFromBase = generateIntegersArray(20);
var ScalesInfo = {
  lp8: {
    name: 'linear',
    factor: 8
  },
  lp2: {
    name: 'linear',
    factor: 2
  },
  lp1: {
    name: 'linear',
    factor: 1
  },
  mn2: {
    name: 'minor-second',
    factor: 1.067
  },
  mj2: {
    name: 'major-second',
    factor: 1.125
  },
  mn3: {
    name: 'minor-third',
    factor: 1.2
  },
  mj3: {
    name: 'major-third',
    factor: 1.25
  },
  p4: {
    name: 'perfect forth',
    factor: 1.333
  },
  a4: {
    name: 'augmented forth',
    factor: 1.414
  },
  p5: {
    name: 'perfect fifth',
    factor: 1.5
  },
  gr: {
    name: 'golden ratio',
    factor: 1.618
  }
};
var nextUpScale = function nextUpScale(factor, base, isLinear) {
  return function (cur) {
    return isLinear ? base + factor * cur : generateIntegersArray(cur).reduce(function (acc) {
      return acc * factor;
    }, base);
  };
};
var nextDownScale = function nextDownScale(factor, base, isLinear) {
  return function (cur) {
    return isLinear ? base - factor * cur : generateIntegersArray(cur).reduce(function (acc) {
      return acc / factor;
    }, base);
  };
};

// lp8 - linear increment 8 px
// lp2 - linear increment 2 px
// lp1 - linear increment 1 px
// MN2 - minor-second scale 1.067 ratio
// MN2 - minor-second scale 1.067 ratio
// MJ2 - major-second scale 1.125 ratio
// MN3 - minor-third scale 1.2 ratio
// MJ3 - major-third scale 1.25 ratio
// P4 - perfect forth scale 1.333 ratio
// A4 - augmented forth scale 1.414 ratio
// P5 - perfect fifth scale 1.5 ratio
// GR - golden ratio scale 1.618 ratio
var generateScaleObject = function generateScaleObject(prefix, factor, base, isPxUnit) {
  var minPx = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 8;
  var maxPx = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : 60;
  var isLinear = prefix.startsWith('l');
  var _base = !isPxUnit ? base * 16 : base;
  var _nextUpScale = nextUpScale(factor, _base, isLinear);
  var _nextDownScale = nextDownScale(factor, _base, isLinear);
  var shouldInclude = function shouldInclude(value) {
    return value >= minPx && value <= maxPx;
  };
  var upScale = ScalesStepsFromBase.reduce(function (acc, cur) {
    var nextValue = _nextUpScale(cur);
    return shouldInclude(nextValue) ? _objectSpread2(_objectSpread2({}, acc), {}, _defineProperty({}, "".concat(prefix, "+").concat(cur), Number((isPxUnit ? nextValue : nextValue / 16).toFixed(3)))) : acc;
  }, {});
  var downScale = ScalesStepsFromBase.reduce(function (acc, cur) {
    var nextValue = _nextDownScale(cur);
    return shouldInclude(nextValue) ? _objectSpread2(_objectSpread2({}, acc), {}, _defineProperty({}, "".concat(prefix, "-").concat(cur), Number((isPxUnit ? nextValue : nextValue / 16).toFixed(3)))) : acc;
  }, {});
  return _objectSpread2(_objectSpread2({}, upScale), downScale);
};

// lp8 - linear increment 8 px
// lp2 - linear increment 2 px
// lp1 - linear increment 1 px
// MN2 - minor-second scale 1.067 ratio
// MJ2 - major-second scale 1.125 ratio
// MN3 - minor-third scale 1.2 ratio
// MJ3 - major-third scale 1.25 ratio
// P4 - perfect forth scale 1.333 ratio
// A4 - augmented forth scale 1.414 ratio
// P5 - perfect fifth scale 1.5 ratio
// GR - golden ratio scale 1.618 ratio
fastMemoize(function (base, scaleUnit) {
  var minPx = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 8;
  var maxPx = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 60;
  var isPxUnit = scaleUnit === 'px';
  var fullScale = _objectSpread2(_objectSpread2(_objectSpread2(_objectSpread2(_objectSpread2(_objectSpread2(_objectSpread2(_objectSpread2(_objectSpread2(_objectSpread2(_objectSpread2(_objectSpread2({
    none: 0
  }, generateScaleObject('lp1', 1, base, isPxUnit, minPx, maxPx)), generateScaleObject('lp2', 2, base, isPxUnit, minPx, maxPx)), generateScaleObject('lp8', 8, base, isPxUnit, minPx, maxPx)), generateScaleObject('mn2', 1.067, base, isPxUnit, minPx, maxPx)), generateScaleObject('mj2', 1.125, base, isPxUnit, minPx, maxPx)), generateScaleObject('mn3', 1.2, base, isPxUnit, minPx, maxPx)), generateScaleObject('mj3', 1.25, base, isPxUnit, minPx, maxPx)), generateScaleObject('p4', 1.333, base, isPxUnit, minPx, maxPx)), generateScaleObject('a4', 1.414, base, isPxUnit, minPx, maxPx)), generateScaleObject('p5', 1.5, base, isPxUnit, minPx, maxPx)), generateScaleObject('gr', 1.61803398875, base, isPxUnit, minPx, maxPx)), {}, {
    base: base
  });
  var sortedKeys = Object.keys(fullScale).sort(function (a, b) {
    return fullScale[a] - fullScale[b];
  });
  return sortedKeys.reduce(function (acc, cur) {
    return _objectSpread2(_objectSpread2({}, acc), {}, _defineProperty({}, cur, fullScale[cur] === 0 ? '0' : "".concat(fullScale[cur]).concat(scaleUnit)));
  }, {});
});
var generateScaleArray = function generateScaleArray(factor, base, isLinear, isPxUnit) {
  var minPx = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 8;
  var maxPx = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : 60;
  var _base = !isPxUnit ? base * 16 : base;
  var _nextUpScale = nextUpScale(factor, _base, isLinear);
  var _nextDownScale = nextDownScale(factor, _base, isLinear);
  var shouldInclude = function shouldInclude(value) {
    return value >= minPx && value <= maxPx;
  };
  var upScale = ScalesStepsFromBase.reduce(function (acc, cur) {
    var nextValue = _nextUpScale(cur);
    return shouldInclude(nextValue) ? [].concat(_toConsumableArray(acc), [Number((isPxUnit ? nextValue : nextValue / 16).toFixed(3))]) : acc;
  }, Array());
  var downScale = ScalesStepsFromBase.reduce(function (acc, cur) {
    var nextValue = _nextDownScale(cur);
    return shouldInclude(nextValue) ? [].concat(_toConsumableArray(acc), [Number((isPxUnit ? nextValue : nextValue / 16).toFixed(3))]) : acc;
  }, Array());
  return [].concat(_toConsumableArray(upScale), _toConsumableArray(downScale));
};
var generateFullScaleArray = fastMemoize(function (base, scaleUnit) {
  var minPx = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 8;
  var maxPx = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 60;
  var isPxUnit = scaleUnit === 'px';
  var fullScale = [0].concat(_toConsumableArray(generateScaleArray(1, base, true, isPxUnit, minPx, maxPx)), _toConsumableArray(generateScaleArray(2, base, true, isPxUnit, minPx, maxPx)), _toConsumableArray(generateScaleArray(8, base, true, isPxUnit, minPx, maxPx)), _toConsumableArray(generateScaleArray(1.067, base, false, isPxUnit, minPx, maxPx)), _toConsumableArray(generateScaleArray(1.125, base, false, isPxUnit, minPx, maxPx)), _toConsumableArray(generateScaleArray(1.2, base, false, isPxUnit, minPx, maxPx)), _toConsumableArray(generateScaleArray(1.25, base, false, isPxUnit, minPx, maxPx)), _toConsumableArray(generateScaleArray(1.333, base, false, isPxUnit, minPx, maxPx)), _toConsumableArray(generateScaleArray(1.414, base, false, isPxUnit, minPx, maxPx)), _toConsumableArray(generateScaleArray(1.5, base, false, isPxUnit, minPx, maxPx)), _toConsumableArray(generateScaleArray(1.61803398875, base, false, isPxUnit, minPx, maxPx)), [
  // GR - golden ratio scale 1.618 ratio
  base]);
  return scaleUnit ? fullScale.sort(function (a, b) {
    return a - b;
  }).map(function (i) {
    return i === 0 ? '0' : "".concat(i).concat(scaleUnit);
  }) : fullScale.sort(function (a, b) {
    return a - b;
  });
});

export { FontScales, ScalesInfo, ScalesStepsFromBase, SpaceScales, generateFullScaleArray, generateScaleObject };
//# sourceMappingURL=scales.esm.js.map
